const clips = [
    {
        id: "dgM9V3lEZvE",
        title: "Hancock",
        subtitle: "Call Me Asshole One More Time",
        duration: "2m 22s",
        category: "Movie Clips",
        people: ["Will Smith", "Jason Bateman", "Daeg Faerch"],
        channelName: "Movieclips",
        channelURL: "https://www.youtube.com/@MOVIECLIPS",
        start: 0,
        end: 142
    },
    {
        id: "R8VswzDwS0c",
        title: "Catch Me if You Can",
        subtitle: "Nobody's Chasing You",
        duration: "3m 8s",
        category: "Movie Clips",
        people: ["Leonardo DiCaprio", "Tom Hanks"],
        channelName: "Movieclips",
        channelURL: "https://www.youtube.com/@MOVIECLIPS"
    },
    {
        id: "IZ_SFbaysHk",
        title: "The Tonight Show",
        subtitle: "Taylor Swift Reacts to Embarrassing Laser Eye Surgery Footage",
        duration: "5m 17s",
        category: "Talk Shows",
        people: ["Tailor Swift", "Jimmy Fallon"],
        channelName: "The Tonight Show Starring Jimmy Fallon",
        channelURL: "https://www.youtube.com/@fallontonight"
    },
    {
        id: "H14bBuluwB8",
        title: "TED",
        subtitle: "Grit: the power of passion and perseverance",
        duration: "6m 12s",
        category: "Talks",
        people: ["Angela Lee Duckworth"],
        channelName: "TED",
        channelURL: "https://www.youtube.com/@TED"
    },
    {
        id: "i3-jlhJgU9U",
        title: "Inception",
        subtitle: "You're in a Dream",
        duration: "2m 3s",
        category: "Movie Clips",
        people: ["Leonardo DiCaprio", "Elliot Page"],
        channelName: "Movieclips",
        channelURL: "https://www.youtube.com/@MOVIECLIPS"
    },
    {
        id: "ep-ieEG06qg",
        title: "The Pursuit of Happyness",
        subtitle: "First Impression",
        duration: "2m 34s",
        category: "Movie Clips",
        people: ["Will Smith", "Brian Howe", "James Karen"],
        channelName: "Movieclips",
        channelURL: "https://www.youtube.com/@MOVIECLIPS"
    },
    {
        id: "UZb2NOHPA2A",
        title: "The Pursuit of Happyness",
        subtitle: "Basketball and Dreams",
        duration: "2m 15s",
        category: "Movie Clips",
        people: ["Will Smith", "Jaden Smith"],
        channelName: "Movieclips",
        channelURL: "https://www.youtube.com/@MOVIECLIPS"
    },
    {
        id: "Z92aHy9-fkk",
        title: "The Hunger Games",
        subtitle: "Get People to Like You",
        duration: "3m 6s",
        category: "Movie Clips",
        people: ["Jennifer Lawrence", "Josh Hutcherson", "Woody Harrelson", "Elizabeth Banks"],
        channelName: "Movieclips",
        channelURL: "https://www.youtube.com/@MOVIECLIPS"
    }
];


export default clips;